export type MasterMenuKey = "clients" | "deliverySpots" | "sites" | "users" | "vehicles";

export type MasterNavKey =
  | "masters-clients"
  | "masters-deliverySpots"
  | "masters-sites"
  | "masters-users"
  | "vehicles";

export type MasterMenuPath =
  | "/masters/clients"
  | "/masters/deliverySpots"
  | "/masters/sites"
  | "/masters/users"
  | "/vehicles";

export interface MasterMenuItem {
  key: MasterMenuKey;
  navKey: MasterNavKey;
  path: MasterMenuPath;
  tabLabel: string;
  navLabel: string;
  title: string;
  sub: string;
  adminOnly?: boolean;
  dispatcherOnly?: boolean;
}

export const MASTER_MENU_ITEMS: readonly MasterMenuItem[] = [
  {
    key: "clients",
    navKey: "masters-clients",
    path: "/masters/clients",
    tabLabel: "取引先",
    navLabel: "取引先",
    title: "取引先マスタ",
    sub: "請求書の宛先となる法人取引先。契約・支払条件の基礎データ。",
  },
  {
    key: "deliverySpots",
    navKey: "masters-deliverySpots",
    path: "/masters/deliverySpots",
    tabLabel: "納品先",
    navLabel: "納品先",
    title: "納品先マスタ",
    sub: "納品先 (届出先) の台帳。現場メモ、担当連絡先、届出履歴。",
  },
  {
    key: "sites",
    navKey: "masters-sites",
    path: "/masters/sites",
    tabLabel: "集荷拠点",
    navLabel: "集荷拠点",
    title: "集荷拠点マスタ",
    sub: "自社・協力会社の集荷センター。住所・営業時間・現場注意事項。",
  },
  {
    key: "users",
    navKey: "masters-users",
    path: "/masters/users",
    tabLabel: "ユーザー",
    navLabel: "スタッフ管理",
    title: "スタッフ管理",
    sub: "管理画面・ドライバーアプリを利用するユーザー。権限・免許期限・招待状態。",
    dispatcherOnly: true,
  },
  {
    key: "vehicles",
    navKey: "vehicles",
    path: "/vehicles",
    tabLabel: "車両",
    navLabel: "車両管理",
    title: "車両管理",
    sub: "配送車両の台帳。最大積載・利用者(リース含む)・荷室寸法。",
  },
];

export function getVisibleMasterMenuItems(
  userRole: string | null | undefined,
): readonly MasterMenuItem[] {
  if (userRole === "admin") return MASTER_MENU_ITEMS;
  if (userRole === "office_staff") return MASTER_MENU_ITEMS.filter((item) => !item.adminOnly);
  return MASTER_MENU_ITEMS.filter((item) => !item.adminOnly && !item.dispatcherOnly);
}
